import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const ImageVet = props => {
    return (
        <StaticImage
            layout="constrained"
            width={500}
            src={"../../images/vet2.jpeg"}
            alt={"Isyflow VET"}
        />
    );
};

export default ImageVet;
